
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
// components
import CompSurveyComment from "../ExerciseComponents/CompSurveyComment.vue";
// interfaces
import { namespace } from "vuex-class";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";

const globals = namespace("globals");

@Component({
  components: {
    CompSurveyComment,
  },
})
export default class CommentElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;

  mounted() {}

}
